import React from "react";
import { Form, Collapse, Button } from "react-bootstrap";
import { CiFilter } from "react-icons/ci";
import { FaFilter } from "react-icons/fa";
import { useCategories } from "../../products/hooks/useCategory";
import { useAgeGroupProduct } from "../../products/hooks/useAgeGroupProduct";
import { useTypeProduct } from "../../products/hooks/useType";

const FilterCardSearch = ({ open, setOpen, filters, handleFilterChange, submitFilter }) => {
    const { categories } = useCategories();
    const { ageGroupProduct } = useAgeGroupProduct();
    const { typeProduct } = useTypeProduct();

    return (
        <Form
            style={{ backgroundColor: 'transparent' }}>
            <Form.Group
                className="d-flex justify-content-between align-items-center"
                onClick={() => setOpen(!open)}
                style={{
                    cursor: "pointer",
                    borderBottom: "2px solid rgb(31, 129, 11)",
                    paddingBottom: "10px",
                    fontSize: 12,
                    backgroundColor: 'transparent'
                }}
            >
                <span>{open ? "Filters" : "Filters"}</span>
                <span>
                    {open ? (
                        <CiFilter size={17} style={{ marginLeft: "auto" }} />
                    ) : (
                        <FaFilter size={17} style={{ marginLeft: "auto" }} />
                    )}
                </span>
            </Form.Group>

            <Collapse in={open} style={{ backgroundColor: 'transparent' }}>
                <div id="filter-collapse">
                    {/* Category Filter */}
                    <Form.Group
                     controlId="filterCategory" 
                     className="mb-1"
                     >
                        <Form.Label style={{ fontSize: 12 }}>Category</Form.Label>
                        <Form.Control
                            as="select"
                            name="category"
                            value={filters.category}
                            onChange={handleFilterChange}
                            style={{ fontSize: 12 }}
                        >
                            <option key='' value=''>Select category . . .</option>
                            {categories.map((category) => (
                                <option key={category.id} value={category.name}>
                                    {category.name}
                                </option>
                            ))}
                        </Form.Control>
                    </Form.Group>

                    {/* Type Filter */}
                    <Form.Group controlId="filterCategory" className="mb-1">
                        <Form.Label style={{ fontSize: 12 }}>Type</Form.Label>
                        <Form.Control
                            as="select"
                            name="type"
                            value={filters.type}
                            onChange={handleFilterChange}
                            style={{ fontSize: 12 }}
                        >
                            <option key='' value=''>Select type . . .</option>
                            {typeProduct.map((type) => (
                                <option key={type.id} value={type.name}>
                                    {type.name}
                                </option>
                            ))}
                        </Form.Control>
                    </Form.Group>

                    {/* Usia Filter */}
                    <Form.Group controlId="filterCategory" className="mb-1">
                        <Form.Label style={{ fontSize: 12 }}>Usia</Form.Label>
                        <Form.Control
                            as="select"
                            name="age"
                            value={filters.age}
                            onChange={handleFilterChange}
                            style={{ fontSize: 12 }}
                        >
                            <option key='' value=''>Select age . . .</option>
                            {ageGroupProduct.map((age) => (
                                <option key={age.id} value={age.name}>
                                    {age.name}
                                </option>
                            ))}
                        </Form.Control>
                    </Form.Group>

                    {/* Jenis Kelamin Filter */}
                    <Form.Group controlId="filterCategory" className="mb-1">
                        <Form.Label style={{ fontSize: 12 }}>Gender</Form.Label>
                        <Form.Control
                            as="select"
                            name="sex"
                            value={filters.sex}
                            onChange={handleFilterChange}
                            style={{ fontSize: 12 }}
                        >
                            <option key='' value=''>Select gender . . .</option>
                            <option value={1}>Laki - laki</option>
                            <option value={2}>Perempuan</option>
                        </Form.Control>
                    </Form.Group>

                    {/* Price Filter */}
                    <Form.Group controlId="filterPrice" className="mb-1">
                        <Form.Label style={{ fontSize: 12 }}>Price Range</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="e.g., Rp.10 - Rp.10000000"
                            name="price"
                            value={filters.price}
                            onChange={handleFilterChange}
                            style={{ fontSize: 12 }}
                        />
                    </Form.Group>

                    <Form.Group controlId="filter" className="mt-2">
                        <Button
                            variant="outline-success"
                            onClick={submitFilter}
                            style={{ width: '100%', fontSize: 12 }}
                        >
                            Filter
                        </Button>
                    </Form.Group>
                </div>
            </Collapse>
        </Form>
    );
};

export default FilterCardSearch;
